import script from "./ImagesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagesCard.vue?vue&type=script&setup=true&lang=js"

import "./ImagesCard.vue?vue&type=style&index=0&id=1aa5bd36&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa5bd36"]])

export default __exports__